'use client'
import { useEffect, useRef } from 'react'

// Animated WebGL dot wave behind the home hero. three.js loads in its own chunk after hydration.
export default function DotWave({ intensity = 1.2 }) {
    const containerRef = useRef(null)

    useEffect(() => {
        let cleanup
        let cancelled = false
        import('./dotWaveScene').then(({ mountDotWave }) => {
            if (!cancelled && containerRef.current) {
                cleanup = mountDotWave(containerRef.current, intensity)
            }
        })
        return () => {
            cancelled = true
            cleanup?.()
        }
    }, [intensity])

    return <div ref={containerRef} style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} aria-hidden="true" />
}
